import { getStaffInviteBodyFromUserContact } from 'src/clinic/components/ClinicHomePage/utils'
import {
  isCommonResponseSuccessful,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { postMPData } from 'src/mentor/services'

export function getInviteObjectsForAllProspectsInBrand(clinicBrand) {
  const prospects = clinicBrand?.prospects

  const allProspects = [
    ...(prospects?.doctors || [])?.map((docCont) => ({
      ...docCont,
      role: 'ROLE_DOCTOR',
    })),
    ...(prospects?.admins || [])?.map((docCont) => ({
      ...docCont,
      role: 'ROLE_CLINIC_ADMINS',
    })),
    ...(prospects?.therapists || [])?.map((docCont) => ({
      ...docCont,
      role: 'ROLE_THERAPIST',
    })),
    ...(prospects?.clinicAssistants || [])?.map((docCont) => ({
      ...docCont,
      role: 'ROLE_CLINIC_ASSISTANT',
    })),
  ]

  const allStaffInvitationObjects = allProspects?.map((pros) => {
    return getStaffInviteBodyFromUserContact(pros, clinicBrand?.id)
  })

  return allStaffInvitationObjects
}

export async function sendInvitesToProspects(clinicBrandData) {
  const allInvites = getInviteObjectsForAllProspectsInBrand(clinicBrandData)

  console.log({ allInvites })
  const resp = await postMPData('/api/secure/cp/send-invitation/multi', allInvites)
  if (resp.status === 200) {
    if (isCommonResponseSuccessfulV2(resp)) {
      //
    }
  }
}
